import bgServices from '../assets/img/ic_our_service_background.png';
import govDtl1 from '../assets/img/ic_services__dtl_1.png';
import educationDtl from '../assets/img/education-study-abroad.jpg';
import visaDtl from '../assets/img/worldwide-visa.jpg';
import tourismDtl from '../assets/img/tourism-travel.jpg';
import eventDtl from '../assets/img/event-management.jpg';
import cruiseDtl from '../assets/img/cruise-booking.jpg';
import insuranceDtl from '../assets/img/travel-insurance.jpg';
import talentAcquisitionDtl from '../assets/img/talentacquisition.png';
import limousineDetailImg from '../assets/img/gallery/carousel/6.jpeg';
import destinationWeddingDetailImg from '../assets/img/desination_wedding.jpg';
import medicalTourismDetailImg from '../assets/img/md_to.jpg';

const services = [
  {
    slug: 'government-documentation',
    title: 'Government Documentation Services',
    short:
      'End-to-end support for all government-related documentation, approvals, and compliance.',
    heroBg: bgServices,
    detailImage: govDtl1,
    intro:
      'We provide end-to-end solutions for all government-related documentation, ensuring that every application, approval, and compliance process is handled accurately, efficiently, and confidentially.',
    assistsWith: [
      'Licenses and permits – business, professional, and personal licenses',
      'Identity and civil documents – passports, ID cards, and family registration services',
      'Government approvals and certifications – for individuals and corporate clients',
      'Renewals and updates – ensuring your documents are always up-to-date and compliant',
      'Legal compliance guidance – navigating rules and regulations to avoid delays or complications',
    ],
    benefits: [
      'Personalized assistance – tailored solutions based on your specific needs',
      'Time-saving efficiency – minimizing bureaucratic delays',
      'Complete confidentiality – safeguarding sensitive information',
    ],
    closing:
      'Our professional approach ensures that every government procedure is completed smoothly, accurately, and on time, giving you peace of mind while we handle the complexities.',
  },
  {
    slug: 'education-study-abroad',
    title: 'Education Consultancy & Study Abroad Services',
    short:
      'Complete guidance for students—from course selection to admissions, visas, and pre-departure support.',
    heroBg: bgServices,
    detailImage: educationDtl,
    intro:
      'At RAYAN STAR Consultancy, we provide comprehensive, end-to-end guidance for students aspiring to study abroad, ensuring a smooth and successful academic journey. Our services are designed to simplify the entire process, from selecting the right course and institution to securing admissions and visas.',
    assistsWith: [
      'Course and University Selection – Personalized guidance to help students choose the most suitable programs and institutions based on their career goals, academic background, and budget.',
      'Application & Admission Support – Preparation of all necessary documents, letters of recommendation, and application submissions to ensure timely and successful admission.',
      'Visa Processing & Guidance – Complete assistance with study visa applications, interviews, and documentation for multiple countries.',
      'Pre-departure Support – Guidance on travel arrangements, accommodation, and cultural adaptation to help students settle smoothly abroad.',
      'Scholarship & Financial Advice – Assistance in identifying scholarships, grants, and financial planning options for international education.',
    ],
    benefits: [
      'Expert Advice – Leveraging our in-depth knowledge of global education systems and admission procedures.',
      'Tailored Solutions – Services customized to each student’s academic goals and personal circumstances.',
      'End-to-End Support – From initial consultation to boarding the plane, we ensure a stress-free and successful study abroad experience.',
    ],
    closing:
      'Our mission is to empower students to achieve their academic dreams globally, providing professional guidance, transparent services, and unwavering support at every step.',
  },
  {
    slug: 'worldwide-visa',
    title: 'Worldwide Visa Services (Tourist, Work, and Business)',
    short:
      'Comprehensive visa support for individuals and corporate clients—accurate, streamlined, and approval-focused.',
    heroBg: bgServices,
    detailImage: visaDtl,
    intro:
      'At RAYAN STAR Consultancy, we provide comprehensive visa services for individuals and corporate clients seeking travel, work, or business opportunities abroad. Our experienced team ensures that every visa application is handled accurately, efficiently, and with a focus on approval success.',
    assistsWith: [
      'Tourist Visas – Assistance with visa applications for short-term travel, holidays, and leisure trips across multiple countries.',
      'Work Visas – Guidance and documentation support for professionals seeking employment abroad, including sponsorship verification, work permits, and employer coordination.',
      'Business Visas – Support for business trips, conferences, trade missions, and international collaborations, ensuring compliance with all regulations.',
      'Student & Dependent Visas – Assistance for family members or dependents accompanying students or professionals abroad.',
      'Visa Documentation & Application Review – Thorough checking and preparation of all required documents to minimize errors and reduce processing delays.',
      'Interview & Embassy Guidance – Coaching and advice for visa interviews to enhance approval chances.',
    ],
    benefits: [
      'Expert Knowledge – Up-to-date understanding of international visa regulations and procedures.',
      'Streamlined Processes – Simplified application processes that save time and reduce stress.',
      'Higher Approval Success Rates – Personalized support and meticulous documentation increase the likelihood of approvals.',
      'Confidential & Professional Service – Secure handling of sensitive personal and corporate information.',
    ],
    closing:
      'Our goal is to make every visa application smooth, reliable, and hassle-free, allowing clients to focus on their travel, work, or business objectives with confidence.',
  },
  {
    slug: 'tourism-travel',
    title: 'Tourism & Travel Services',
    short:
      'Customized travel planning, reservations, documentation help, and 24/7 support for worry-free journeys.',
    heroBg: bgServices,
    detailImage: tourismDtl,
    intro:
      'At RAYAN STAR Consultancy, we provide comprehensive travel solutions for clients seeking hassle-free, enjoyable, and memorable experiences worldwide. Our team of travel experts ensures that every aspect of your journey, from planning to execution, is handled with precision, professionalism, and personalized attention.',
    assistsWith: [
      'Customized Holiday Packages – Tailor-made travel itineraries designed to suit your preferences, interests, and budget, whether it’s leisure, adventure, or luxury travel.',
      'Ticketing & Reservations – Efficient booking of flights, trains, buses, and accommodations to ensure smooth travel planning.',
      'Travel Documentation Assistance – Guidance in preparing and verifying all necessary travel documents, including passports, visas, travel insurance, and permits.',
      'Corporate & Group Travel Management – Specialized support for businesses and organizations, including conference trips, corporate retreats, and group tours.',
      'Travel Consultation & Advice – Expert recommendations on destinations, travel routes, safety measures, and cultural insights to make your trip enjoyable and stress-free.',
      '24/7 Support – Assistance during your travel to resolve any unexpected issues or changes promptly.',
    ],
    benefits: [
      'Personalized Service – Every itinerary and travel plan is customized to your unique needs and goals.',
      'Seamless Experience – From booking to return, every step of the journey is managed efficiently to minimize stress and maximize enjoyment.',
      'Global Reach – Access to travel opportunities and solutions worldwide, backed by our professional expertise.',
      'Memorable Journeys – Our aim is not just to take you places, but to create experiences that leave lasting memories.',
    ],
    closing:
      'Our mission in tourism and travel is to turn every journey into a seamless, enriching, and unforgettable experience, combining convenience, safety, and excitement for all our clients.',
  },
  {
    slug: 'event-management',
    title: 'Event Management',
    short:
      'End-to-end planning and flawless execution for corporate, social, and private events.',
    heroBg: bgServices,
    detailImage: eventDtl,
    intro:
      'At RAYAN STAR Consultancy, we provide end-to-end event management solutions for corporate, social, and private occasions, ensuring every event is executed flawlessly and leaves a lasting impression. Our experienced team combines creativity, organization, and professionalism to deliver events that reflect your vision and exceed expectations.',
    assistsWith: [
      'Corporate Events – Planning and managing conferences, seminars, workshops, product launches, and corporate gatherings with meticulous attention to detail.',
      'Social & Private Events – Customized management of weddings, anniversaries, birthdays, and family celebrations, tailored to your style and preferences.',
      'Venue Selection & Decor – Assistance in choosing the perfect venue and creating thematic, elegant, and memorable decor.',
      'Event Coordination & Logistics – Complete handling of scheduling, vendor management, catering, transportation, and on-site coordination.',
      'Entertainment & Programs – Organizing performances, speakers, and activities to engage and delight guests.',
      'Budgeting & Planning – Strategic planning to ensure events are delivered within budget without compromising quality.',
      'Post-Event Services – Feedback collection, documentation, and follow-up to ensure client satisfaction and continuous improvement.',
    ],
    benefits: [
      'Personalized Solutions – Every event is tailored to your vision, purpose, and audience.',
      'Professional Execution – Experienced coordinators manage every detail to ensure a seamless experience.',
      'Stress-Free Experience – We handle all logistics and coordination, allowing you to enjoy your event.',
      'Memorable Outcomes – Our goal is to create events that are not only successful but truly memorable for every participant.',
    ],
    closing:
      'Our mission in event management is to transform ideas into flawlessly executed experiences, combining creativity, precision, and professionalism for events that impress and inspire.',
  },
  {
    slug: 'cruise-booking',
    title: 'Cruise Booking Services – Worldwide',
    short:
      'Luxury cruise planning with destination options, cabin selection, itineraries, and documentation support.',
    heroBg: bgServices,
    detailImage: cruiseDtl,
    intro:
      'At RAYAN STAR Consultancy, we provide comprehensive cruise booking services, allowing clients to enjoy luxurious, memorable, and hassle-free sea voyages across the globe. Whether it’s a romantic getaway, family vacation, or corporate retreat, our team ensures every detail of your cruise experience is carefully planned and personalized.',
    assistsWith: [
      'Worldwide Cruise Destinations – Assistance in booking cruises across popular destinations such as the Mediterranean, Caribbean, Alaska, Southeast Asia, Europe, and more.',
      'Luxury & Themed Cruises – Options for luxury liners, all-inclusive cruises, adventure-themed cruises, and special seasonal itineraries.',
      'Cabin Selection & Upgrades – Guidance on selecting the best cabins, suites, or family rooms based on your preferences and budget, including VIP and premium options.',
      'Itinerary Planning – Customized itineraries covering ports of call, shore excursions, onboard activities, and entertainment tailored to your interests.',
      'Booking & Documentation Assistance – Handling all cruise bookings, payment procedures, and necessary travel documentation, including cruise visas where applicable.',
      'Onboard & Shore Services – Guidance on onboard amenities such as dining, wellness, entertainment, and shore excursions to maximize your cruise experience.',
      'Corporate & Group Cruises – Planning group or corporate cruises for team-building, conferences, or special events, with dedicated assistance for logistics and coordination.',
    ],
    benefits: [
      'Expert Advice & Planning – Experienced staff help select the ideal cruise experience based on your interests, duration, and budget.',
      'Personalized Services – Every cruise is customized to ensure a unique and memorable experience.',
      'Hassle-Free Experience – We manage bookings, documentation, and logistics so you can relax and enjoy your journey.',
      'Worldwide Access – Exclusive partnerships with cruise operators globally, ensuring a wide selection of options and competitive prices.',
    ],
    closing:
      'Our mission is to make cruise vacations stress-free, luxurious, and unforgettable, offering personalized guidance, seamless bookings, and exceptional support from departure to return.',
  },
  {
    slug: 'travel-insurance',
    title: 'Travel Insurance Services',
    short:
      'Comprehensive coverage options to protect your journey—medical, cancellation, luggage, and emergency support.',
    heroBg: bgServices,
    detailImage: insuranceDtl,
    intro:
      'At RAYAN STAR Consultancy, we provide comprehensive travel insurance solutions to ensure that every journey is safe, secure, and worry-free. Whether you are traveling for leisure, business, study, or work abroad, our insurance services protect you against unexpected events, giving peace of mind throughout your trip.',
    assistsWith: [
      'Medical Coverage – Protection against medical emergencies, hospitalization, and treatment costs while traveling abroad.',
      'Trip Cancellation & Interruption – Coverage for unforeseen circumstances such as illness, flight delays, or personal emergencies that may disrupt your travel plans.',
      'Lost or Delayed Luggage – Compensation and support in case of lost, stolen, or delayed baggage.',
      'Accidental Coverage – Financial protection for accidents or injuries occurring during your trip.',
      'Emergency Assistance Services – 24/7 support for medical emergencies, travel guidance, and assistance in foreign countries.',
      'Customized Plans – Tailored insurance packages for tourists, students, business travelers, and workers abroad to meet specific requirements.',
      'Family & Group Coverage – Options for families or corporate groups traveling together, ensuring complete protection for all members.',
    ],
    benefits: [
      'Expert Guidance – Assistance in selecting the right insurance plan based on destination, duration, and travel purpose.',
      'Global Coverage – Access to reputable international insurance providers for worldwide protection.',
      'Seamless Process – Easy application, quick approvals, and clear documentation.',
      'Peace of Mind – Focus on enjoying your journey while we take care of all insurance needs.',
    ],
    closing:
      'Our mission is to ensure that every trip is safe, secure, and worry-free, giving travelers the confidence to explore, work, or study abroad without concerns about unexpected situations.',
  },
  {
    slug: 'destination-weddings',
    title: 'Destination Weddings',
    short:
      'Stunning destination celebrations—handled end-to-end with planning, décor, and guest hospitality.',
    heroBg: bgServices,
    detailImage: destinationWeddingDetailImg,
    intro:
      'Make your dream wedding unforgettable with stunning destination celebrations. We handle everything from venue selection and event planning to guest hospitality and décor, ensuring a seamless and memorable experience.',
    assistsWith: [
      'Venue selection & site visits – shortlist the best destination venues that match your style and budget',
      'End-to-end wedding planning – timelines, vendor coordination, and day-of execution',
      'Décor & theme design – stage, floral, lighting, and ambience planning',
      'Guest hospitality – travel coordination, welcome desk, and on-ground support',
      'Ceremony & celebration programs – itinerary planning for functions and entertainment',
    ],
    benefits: [
      'Stress-free planning – one team coordinating all moving parts',
      'Premium aesthetics – curated décor and experience-led design',
      'Reliable execution – clear timelines, vendor management, and on-site supervision',
    ],
    closing:
      'Our goal is to deliver a flawless destination wedding experience—beautifully planned, professionally managed, and remembered for a lifetime.',
  },
  {
    slug: 'limousine-chauffeur-services',
    title: 'Limousine / Chauffeur Services',
    short:
      'Luxury, comfort, and style—chauffeur-driven vehicles for weddings, events, and corporate travel.',
    heroBg: bgServices,
    detailImage: limousineDetailImg,
    intro:
      'Experience luxury, comfort, and style with our premium transportation services. From weddings to corporate travel, our chauffeur-driven vehicles ensure a smooth and elegant journey every time.',
    assistsWith: [
      'Wedding & VIP transfers – punctual, premium arrivals and departures',
      'Corporate travel – executive transport for meetings, events, and delegations',
      'Airport transfers – meet & greet coordination and luggage support',
      'Hourly / full-day bookings – flexible plans for schedules and multi-stop trips',
      'Event transportation – coordinated pickups and drop-offs for guests and teams',
    ],
    benefits: [
      'Comfort & safety – trained chauffeurs and well-maintained vehicles',
      'On-time service – schedule-aware coordination to avoid delays',
      'Premium experience – professional, discreet, and polished travel',
    ],
    closing:
      'We deliver dependable premium transportation that elevates every occasion—smooth, elegant, and always on time.',
  },
  {
    slug: 'talent-acquisition',
    title: 'Talent Acquisition',
    short:
      'Recruitment, staffing, and event personnel solutions—matching the right talent to the right roles.',
    heroBg: bgServices,
    detailImage: talentAcquisitionDtl,
    intro:
      'We connect the right talent with the right opportunities. Our services include recruitment, staffing, and event personnel solutions, helping businesses and events run efficiently with skilled professionals.',
    assistsWith: [
      'Recruitment & hiring – sourcing, screening, and shortlisting candidates',
      'Contract & temporary staffing – flexible workforce solutions for peak needs',
      'Event personnel – coordinators, promoters, ushers, and support staff',
      'Role profiling – job descriptions, requirements, and interview frameworks',
      'Onboarding support – documentation checks and joining coordination',
    ],
    benefits: [
      'Faster hiring – streamlined sourcing and screening processes',
      'Better fit – role-based matching for skills, attitude, and culture',
      'Operational efficiency – reliable staffing support for projects and events',
    ],
    closing:
      'Our mission is to help organizations and events run smoothly by delivering dependable talent—quickly, professionally, and with the right fit.',
  },
  {
    slug: 'medical-tourism',
    title: 'Medical Tourism to India',
    short: 'Affordable • Advanced • Trusted Care',
    heroBg: bgServices,
    detailImage: medicalTourismDetailImg,
    detailLayout: 'medical-india',
    intro: '',
    assistsWith: [],
    benefits: [],
    closing: '',
    medicalIndia: {
      introParagraphs: [
        'RAYAN STAR CONSULTANCY & SERVICES W.L.L. proudly connects you to world-class medical treatment in India, where advanced healthcare meets unmatched affordability.',
        'India has become one of the most preferred global destinations for medical tourism, offering high-quality treatments at a fraction of international costs, without compromising on safety, technology, or patient care.',
      ],
      whyIndia: [
        {
          title: 'Cost-Effective Solutions',
          text: 'Save up to 70% on major treatments compared to Western countries.',
        },
        {
          title: 'International Standard Hospitals',
          text: 'Equipped with latest technology and globally accredited facilities.',
        },
        {
          title: 'Expert Doctors',
          text: 'Highly experienced specialists trained to handle complex medical cases.',
        },
        {
          title: 'Minimal Waiting Time',
          text: 'Fast appointments and quick treatment scheduling.',
        },
      ],
      supportIntro:
        'At RAYAN STAR CONSULTANCY, we provide end-to-end assistance for your medical journey:',
      supportItems: [
        'Medical consultation & hospital selection',
        'Medical visa processing',
        'Flight booking & travel arrangements',
        'Airport pickup & accommodation',
        'Hospital admission and treatment coordination',
        'Translation & patient support services',
        'Post-treatment follow-up',
      ],
      nursingIntro: 'We ensure you receive compassionate and professional care throughout your treatment:',
      nursingItems: [
        '24/7 dedicated nursing support',
        'Personalized patient care and monitoring',
        'Assistance with recovery and rehabilitation',
        'Hygiene, comfort, and emotional support',
        'Your health and comfort are our top priorities.',
      ],
      popularTreatments: [
        'Cardiac Surgeries (Bypass, Valve Replacement)',
        'Orthopedic (Knee & Hip Replacement)',
        'Cancer Treatment',
        'Fertility Treatments (IVF)',
        'Cosmetic & Plastic Surgery',
        'Neurology & Spine Surgery',
      ],
      holisticParagraph:
        'Along with modern medicine, India also offers natural healing through Ayurveda, focusing on complete wellness and recovery.',
      whyChooseUs: [
        'Trusted and professional service',
        'Personalized guidance for every patient',
        'Strong network of top hospitals in India',
        'Hassle-free and transparent process',
      ],
      contactCta: {
        headline: 'Contact us today',
        subline: 'Start your journey towards affordable and world-class healthcare.',
        companyLine: 'RAYANSTAR CONSULTANCY & SERVICES W.L.L.',
        location: 'Manama, Bahrain',
        phoneDisplay: '+973 3367 1307',
        phoneTel: '+97333671307',
      },
    },
  },
];

export function getServiceBySlug(slug) {
  return services.find((s) => s.slug === slug);
}

export default services;

